import Cookies, { CookieSetOptions } from "universal-cookie";
import config from "../../../../config/default";
import { IQueryParams } from "../../../../contexts/params/IParamsContext";

const cookies = new Cookies();

export const setCookie = (
  name: string,
  value: string,
  options: Partial<CookieSetOptions> = {}
): void => {
  cookies.set(name, value, {
    path: "/",
    domain: config.domain,
    secure: config.secureTokens,
    ...options,
  });
};

export const setCookiesAccessToken = (accessToken: string) => {
  setCookie("accessToken", accessToken);
};

export const setCookiesRefreshToken = (refreshToken: string) => {
  setCookie("refreshToken", refreshToken);
};

export const validateUrlParameters = (params: IQueryParams) => {
  const redirectURL = params.url;
  const rules = params.rules;
  const redirectPath = params.path;

  if (!redirectURL) {
    throw new Error(
      "Ausência de Parâmetros na Url - link de Redirecionamento (url off)"
    );
  }

  if (!rules) {
    throw new Error(
      "Ausência de Parâmetros na Url - regras do projeto (rules off)"
    );
  }

  return { redirectURL, rules, redirectPath };
};

export const checkTokenInParams = (): boolean => {
  const url = window.location.href;

  const hashIndex = url.indexOf("#");
  if (hashIndex === -1) return false;

  const hash = url.slice(hashIndex + 1); // ex: "/login?token=abc123"
  const queryIndex = hash.indexOf("?");
  if (queryIndex === -1) return false;

  const queryString = hash.slice(queryIndex + 1); // "token=abc123"
  const params = new URLSearchParams(queryString);

  return params.has("token");
};

export const getRulesFromUrl = (): string | null => {
  const url = window.location.href;

  const hashIndex = url.indexOf("#");
  if (hashIndex === -1) return null;

  const hash = url.slice(hashIndex + 1);

  const params = new URLSearchParams(hash.split("?")[1]);

  return params.get("rules");
};

export const getTokenDecodedFromUrl = (): string | null => {
  const url = window.location.href;

  const hashIndex = url.indexOf("#");
  if (hashIndex === -1) return null;

  const hash = url.slice(hashIndex + 1);

  const params = new URLSearchParams(hash.split("?")[1]);

  const token = params.get("token");

  if (!token) return null;

  try {
    return atob(token);
  } catch (error) {
    console.error("Erro ao decodificar o token: ", error);
    return null;
  }
};
